import React, { useState, useEffect } from 'react';
import { useCurrentAccount } from '@mysten/dapp-kit';
import EnokiLoginButton from '../EnokiLoginButton';

const SettingsModal = ({
    isOpen,
    onClose,
    showBackButton = true,
    backButtonText = "← Back to Game",
    onBackClick = null
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const currentAccount = useCurrentAccount();

    // 處理返回按鈕點擊
    const handleBackClick = () => {
        if (onBackClick) {
            onBackClick();
        } else {
            window.history.back();
        }
    };

    // ESC 關閉 modal
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);

    // 如果 modal 未開啟，不渲染
    if (!isOpen) {
        return null;
    }

    return (
        <>
            {/* Modal Overlay - 使用首頁樣式 */}
            <div
                className="home-modal-overlay"
                onClick={(e) => {
                    if (e.target.classList.contains('home-modal-overlay')) {
                        onClose();
                    }
                }}
            >
                <div className="home-modal-content">
                    <div className="home-modal-items">
                        {/* 登入區域 */}
                        <div className="home-modal-item">
                            <div className="home-modal-item-title">🔐 Google Login</div>
                            <div className="home-modal-item-desc">Securely log in with Google via Enoki zkLogin.</div>
                            {currentAccount ? (
                                <div style={{ marginBottom: '10px' }}>
                                    <div className="home-modal-wallet-info">
                                        <div className="home-modal-wallet-address">
                                            {currentAccount.address.slice(0, 6)}...{currentAccount.address.slice(-4)}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            <EnokiLoginButton className="home-modal-btn" />
                        </div>

                        {/* TWENTY → USDC 交換 */}
                        {/* <div className="home-modal-item">
                            <div className="home-modal-item-title">🔄 TWENTY → USDC</div>
                            <a href="/20sui/twenty-to-usdc" className="home-modal-btn">Go to Swap</a>
                        </div> */}

                        {/* 排行榜 */}
                        {/* <div className="home-modal-item">
                            <div className="home-modal-item-title">🏆 Leaderboard</div>
                            <a href="/20sui/leaderboard" className="home-modal-btn">View Rankings</a>
                        </div> */}

                        {/* 返回按鈕 (可選) */}
                        {showBackButton && (
                            <div className="home-modal-item">
                                <div className="home-modal-item-title">🔙 Navigation</div>
                                <button
                                    className="home-modal-btn"
                                    onClick={handleBackClick}
                                    style={{ background: '#6c757d' }}
                                >
                                    {backButtonText}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SettingsModal;
